import BaseVisualizationService from '@configuratorware/configurator-frontendgui/App/Services/VisualizationService';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { createAdapterConfig } from 'redhotmagma-visualization/visualizationAdapterCreator';
import Three2dVariant from '../Visualization/Three2dVariant';

export default class VisualizationService extends BaseVisualizationService {
  adapterConfig = createAdapterConfig(
    { host: getConf('network.host') },
    {
      '2dVariant': {
        adapterClass: Three2dVariant,
      },
    }
  );

  setDesignAreaScreenshotMode(on) {
    this.getComponent().designAreaScreenshotMode = on;
  }

  setDefaultDesignView(designView) {
    this.getComponent().defaultDesignView = designView;
  }
}
